import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { PostoTrocaInterface } from '@/shared/models/posto/posto-troca.interface';
import { PostoTrocaFilter } from '@/shared/models/posto/posto-troca.filter';
import { ProdutoInterface } from '@/shared/models/produto/produto.interface';
import store from '@/store';
import queryUtil from '@/shared/utils/query.util';
import Format from '@/shared/utils/format.util';
import { AxiosError, AxiosResponse } from 'axios';
import { instanciaAxios } from './base.service';

const postoTroca = 'pontos-venda';

export default class ProdutoService {
  async buscarTodos(): Promise<Array<PostoTrocaInterface> | null> {
    return await instanciaAxios.get(postoTroca)
      .then((response: AxiosResponse) => response.data)
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorCNPJ(cnpj: string): Promise<any> {
    return await instanciaAxios.get(`${postoTroca}/${cnpj}`)
      .then((response: any) => {
        const posto: PostoTrocaInterface = response.data;
        return posto;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorFiltro(filtro: PostoTrocaFilter): Promise<any> {
    const filtroPesquisa = { ...filtro };
    if (filtroPesquisa.cnpj !== undefined && filtroPesquisa.cnpj !== null) {
      filtroPesquisa.cnpj = Format.semPontoTracoBarra(filtroPesquisa.cnpj);
    }
    const query = queryUtil.getQuery(filtroPesquisa);
    return await instanciaAxios.get(`${postoTroca}/pesquisa${query}`)
      .then((response: any) => {
        const lista: Array<PostoTrocaInterface> = response.data;
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async atualizar(body: PostoTrocaInterface): Promise<any> {
    body.cnpj = Format.cnpj(body.cnpj);
    await instanciaAxios.put(`${postoTroca}/${body.cnpj}`, body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Posto de Troca editado com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async vincularProduto(cnpj: string, ean: number): Promise<any> {
    await instanciaAxios.put(`${postoTroca}/${cnpj}/vincular-produto/${ean}`)
      .then(() => {
        // store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Produto vinculado com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async desvincularProduto(cnpj: string, ean: number): Promise<any> {
    await instanciaAxios.put(`${postoTroca}/${cnpj}/desvincular-produto/${ean}`)
      .then(() => {
        // store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Produto desvinculado com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async recuperarProdutosPorCNPJ(cnpj: string): Promise<any> {
    return await instanciaAxios.get(`${postoTroca}/produtos-vinculados/${cnpj}`)
      .then((response: any) => {
        const produtos: Array<ProdutoInterface> = response.data;
        return produtos;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async vincularRegra(cnpj: string, codigo: string): Promise<any> {
    await instanciaAxios.put(`${postoTroca}/${cnpj}/vincular-regra/${codigo}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Vinculo Efetuado!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async desvincularRegra(cnpj: string): Promise<any> {
    await instanciaAxios.put(`${postoTroca}/${cnpj}/desvincular-regra`)
      .then(() => {
        // store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra desvinculada com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async recuperarRegraPorCNPJ(cnpj: string): Promise<any> {
    return await instanciaAxios.get(`${postoTroca}/regra-vinculada/${cnpj}`)
      .then((response: any) => {
        const produtos: Array<ProdutoInterface> = response.data;
        return produtos;
      })
      .catch((error: any) => {
        if (error.response.status === 500 && error.response.data.indexOf('No entity found for query') !== -1) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhuma Regra Vinculada!');
        } else {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        }
        console.error(error);
      });
  }

  async recuperarRegraPorCNPJSemSnackBar(cnpj: string): Promise<any> {
    return await instanciaAxios.get(`${postoTroca}/regra-vinculada/${cnpj}`)
      .then((response: any) => {
        const produtos: Array<ProdutoInterface> = response.data;
        return produtos;
      })
      .catch((error: any) => {
        if (!(error.response.status === 500 && error.response.data.indexOf('No entity found for query') !== -1)) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        }
        console.error(error);
      });
  }
}
